export default __webpack_public_path__ + "static/media/Inserts.6cbaeb92.png";